export default __webpack_public_path__ + "static/media/twitter-icon.af052d0d.svg";